<template>
  <div class="page-container">
    <el-card>
      <div slot="header">
        <span>COS存储管理</span>
      </div>
      <el-form inline>
        <el-form-item label="文件路径">
          <el-input v-model="key" placeholder="输入COS文件路径"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="restore">恢复文件</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="list" v-loading="loading" style="width: 100%">
        <el-table-column prop="key" label="文件路径"></el-table-column>
        <el-table-column prop="status" label="状态" width="120"></el-table-column>
        <el-table-column prop="size" label="大小" width="120"></el-table-column>
        <el-table-column prop="lastModified" label="最后修改" width="180"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { vpost } from "@/util/post";

export default {
  name: "CosManage",
  data() {
    return { list: [], loading: false, key: "" };
  },
  mounted() { this.fetchData(); },
  methods: {
    fetchData() {
      this.loading = true;
      vpost("/cos/list").then(res => {
        if (res.code === 200) this.list = res.data || [];
      }).finally(() => this.loading = false);
    },
    restore() {
      if (!this.key) return this.$message.error("请输入文件路径");
      vpost("/cos/restore", { key: this.key }).then(res => {
        if (res.code === 200) {
          this.$message.success("恢复请求已提交");
          this.fetchData();
        }
      });
    }
  }
};
</script>
